module.exports = __webpack_public_path__ + "img/ic_publicity_detail4_4.6a47b94c.jpeg";